module.exports = __webpack_public_path__ + "img/lb_menu_bg_d_1.7ff60d06.png";